const WEBHOOK_URL = process.env.REACT_APP_SHEETS_WEBHOOK_URL;

// Fire-and-forget POST to a Google Apps Script Web App that appends a row
// to the given sheet tab. Never blocks or throws into the caller's flow.
export const saveToSheet = (sheetName, row) => {
  if (!WEBHOOK_URL) return;
  try {
    fetch(WEBHOOK_URL, {
      method: 'POST',
      body: JSON.stringify({ sheetName, row }),
    }).then((res) => {
      if (!res.ok && process.env.NODE_ENV === 'development') {
        console.error('Sheets webhook returned non-OK status:', res.status);
      }
    }).catch((error) => {
      if (process.env.NODE_ENV === 'development') {
        console.error('Failed to save to sheet:', error);
      }
    });
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.error('Failed to save to sheet:', error);
    }
  }
};
